export default function TranslucentXMark() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M15.8192 4.96178C15.9309 4.85586 15.986 4.72529 15.986 4.57148C15.986 4.41767 15.9309 4.2842 15.8192 4.17249C15.7133 4.06658 15.5827 4.01434 15.4289 4.01434C15.2751 4.01434 15.1416 4.06658 15.0299 4.17249L9.85737 9.35355L4.67631 4.17249C4.5704 4.06658 4.43983 4.01434 4.28602 4.01434C4.13221 4.01434 3.99874 4.06658 3.88703 4.17249C3.78111 4.28421 3.72888 4.41769 3.72888 4.57148C3.72888 4.72527 3.78111 4.85584 3.88703 4.96178L9.06809 10.1428L3.88703 15.3153C3.78111 15.4271 3.72888 15.5605 3.72888 15.7143C3.72888 15.8681 3.78111 15.9987 3.88703 16.1046C3.99875 16.2164 4.13223 16.2715 4.28602 16.2715C4.43981 16.2715 4.57038 16.2164 4.67631 16.1046L9.85737 10.9321L15.0299 16.1046C15.1416 16.2164 15.2751 16.2715 15.4289 16.2715C15.5827 16.2715 15.7132 16.2164 15.8192 16.1046C15.9309 15.9987 15.986 15.8681 15.986 15.7143C15.986 15.5605 15.9309 15.4271 15.8192 15.3153L10.6467 10.1428L15.8192 4.96178Z"
          fill="#FFFFF2"
        />
      </g>
    </svg>
  );
}
